module.exports = __webpack_public_path__ + "static/img/RWA1264_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA1264_1.png
// module id = +zmj
// module chunks = 0